<script>
    /*
    	ServiceFieldsGroup6Stats.svelte

        Stats - 5 fields

        Expandable/Collapsible and contains a predetermined set of DataFields
    */

    import { onMount } from 'svelte';
    // import { shallowArraysEqual } from '../../common/utils.js';

    // TCARE components
    import DataTextField from '../data-fields/DataTextField.svelte';
    import FieldGroupExpandBar from './FieldGroupExpandBar.svelte';

    // SMUI components
    import { ID, CREATED_AT, UPDATED_AT, LAT, LON } from '../../common/constants.js';

    // const FIELDS = [ ID, CREATED_AT, UPDATED_AT, LAT, LON ];
    const GROUP_TITLE = 'Fixed Values';

    export let store;                   // store is a Service store - not just data!
    export let leftService;
    export let rightService;
    export let onCopyValue;
    export let isEditable;
    export let isOpen;
    export let showDiffs;               // bypass the strike-through and highlighting

    $: apiData = $store.apiData;
    $: isExpanded = isOpen;

    onMount(() => {
        // console.log('ServiceFieldsGroup4 onMount');
    })

    const toggleIsExpanded = () => {
        isExpanded = !isExpanded;
    }

    const isFieldDiff = (propName) => {
        if (!leftService) return false;
        if (!rightService) return false;
        return leftService[propName] !== rightService[propName];
    }

    
</script>

<style>
    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="field-group">
    
    <FieldGroupExpandBar title={GROUP_TITLE} {isExpanded} {toggleIsExpanded} />

    {#if apiData && isExpanded}
        <div class="fields-area">

            <!-- left and right blocks in a fluid row -->
            <div class="flex-row ai-start fluid">

                <div class="flex-block w-49">
                    <DataTextField
                        value={apiData[ID]}
                        propName={ID}
                        label={'ID'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(ID)}
                        isNewDiff={isFieldDiff(ID)}
                        onCopyValue={onCopyValue}
                        tooltip={apiData[ID]}
                        showDiffs={showDiffs}
                    />
                    <DataTextField
                        value={apiData[CREATED_AT]}
                        propName={CREATED_AT}
                        label={'Created'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(CREATED_AT)}
                        isNewDiff={isFieldDiff(CREATED_AT)}
                        onCopyValue={onCopyValue}
                        tooltip={apiData[CREATED_AT]}
                        showDiffs={showDiffs}
                    />
                    <DataTextField
                        value={apiData[UPDATED_AT]}
                        propName={UPDATED_AT}
                        label={'Updated'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(UPDATED_AT)}
                        isNewDiff={isFieldDiff(UPDATED_AT)}
                        onCopyValue={onCopyValue}
                        tooltip={apiData[UPDATED_AT]}
                        showDiffs={showDiffs}
                    />
                </div>

                <div class="flex-block w-49">
                
                    <DataTextField
                        value={apiData[LAT]}
                        propName={LAT}
                        label={'Lat'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(LAT)}
                        isNewDiff={isFieldDiff(LAT)}
                        onCopyValue={onCopyValue}
                        tooltip={apiData[LAT]}
                        showDiffs={showDiffs}
                    />
                    <DataTextField
                        value={apiData[LON]}
                        propName={LON}
                        label={'Lon'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(LON)}
                        isNewDiff={isFieldDiff(LON)}
                        onCopyValue={onCopyValue}
                        tooltip={apiData[LON]}
                        showDiffs={showDiffs}
                    />
                </div>
            </div>
        </div>
    {/if}
</div>
